<template>
  <div class="app-container">
    <el-row :gutter="20">
      <!-- 标准列表 -->
      <el-col :span="24" :xs="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <el-row :gutter="20">
              <el-col :span="18">
                <!-- 使用自定义工具栏按钮组件 -->
                <PermissionMethodToolbar :url="url" :id="'toolbar'" @handleAdd="handleAdd" @handleExport="handleExport" />
              </el-col>
              <el-col :span="6">
                <el-input v-model="queryParams.standardName" placeholder="请输入标准名称搜索" clearable size="small" prefix-icon="el-icon-search" @keyup.enter.native="handleSearch" />
              </el-col>
            </el-row>
          </div>

          <el-table :data="standardList" border style="width: 100%" @row-click="handleRowClick" :row-class-name="tableRowClassName" v-loading="loading">
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column prop="standardCode" label="检测标准编号" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="standardName" label="检测标准名称" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="standardApproveOrg" label="检测标准发布机构" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="standardExecuteDate" label="检测标准执行日期" width="150" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.standardExecuteDate ? scope.row.standardExecuteDate.split(' ')[0] : '' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="standardApproveDate" label="检测标准发布日期" width="150" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.standardApproveDate ? scope.row.standardApproveDate.split(' ')[0] : '' }}</span>
                  </template>
            </el-table-column>
            <el-table-column prop="standardCancelDate" label="检测标准废止日期" width="150" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.standardCancelDate ? scope.row.standardCancelDate.split(' ')[0] : '' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="标准文件" width="200">
              <template slot-scope="scope">
                <span v-if="scope.row.standardFileUUID">{{ scope.row.standardFileUUID }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="fileName" label="文件名" min-width="150" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.fileName">{{ scope.row.fileName }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column> -->
            <el-table-column prop="remark" label="备注" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" width="150" align="center" fixed="right">
              <template slot-scope="scope">
                <!-- 使用自定义行操作按钮组件 -->
                <PermissionMethodRow :url="url" :id="'rowtoolbar'" @handleEdit="handleEdit(scope.row)" @handleDelete="handleDelete(scope.row)" />
              </template>
            </el-table-column>
          </el-table>

          <el-pagination v-show="total > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.currPage" :page-sizes="[10, 20, 30, 50]"
                         :page-size="queryParams.pageSize" :total="total" layout="total, sizes, prev, pager, next, jumper" style="margin-top: 20px; text-align: center;">
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <!-- 新增/修改标准对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" @close="handleDialogClose">
      <el-form ref="standardForm" :model="formData" :rules="formRules" label-width="140px">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="检测标准编号" prop="standardCode">
              <el-input v-model="formData.standardCode" placeholder="请输入检测标准编号" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="检测标准名称" prop="standardName">
              <el-input v-model="formData.standardName" placeholder="请输入检测标准名称" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="检测标准发布机构" prop="standardApproveOrg">
              <el-input v-model="formData.standardApproveOrg" placeholder="请输入检测标准发布机构" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="检测标准执行日期" prop="standardExecuteDate">
              <el-date-picker v-model="formData.standardExecuteDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择检测标准执行日期" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="检测标准发布日期" prop="standardApproveDate">
              <el-date-picker v-model="formData.standardApproveDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择检测标准发布日期" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="检测标准废止日期" prop="standardCancelDate">
              <el-date-picker v-model="formData.standardCancelDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择检测标准废止日期" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="选择文件">
              <el-upload class="upload-demo" drag :action="uploadAction" :headers="uploadHeaders" :on-success="handleFileSuccess" :on-error="handleFileError" :before-upload="beforeFileUpload"
                         :file-list="fileList" :limit="1" :auto-upload="true" :http-request="uploadFile" ref="fileUpload">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">只能上传doc/docx/xls/xlsx/pdf文件，且不超过10MB</div>
              </el-upload>
              <!-- 显示上传进度 -->
              <div v-if="tipText" style="margin-top: 10px;">
                <el-progress :percentage="uploadProgress" :show-text="false"></el-progress>
                <span style="font-size: 12px; color: #666;">{{ tipText }}</span>
              </div>
              <div v-if="formData.fileName" class="file-info">
                <el-tag type="success">{{ formData.fileName }}</el-tag>
                <el-button type="text" @click="previewFileInDialog">预览</el-button>
                <el-button type="text" @click="clearFile">清除文件</el-button>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="formData.remark" type="textarea" :rows="3" placeholder="请输入备注" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
    <!-- PDF预览对话框 -->
    <el-dialog title="文件预览" :visible.sync="isPdfViewVisible" width="80%" append-to-body>
      <PdfImgViewer ref="pdfImgViewer" :fileName="viewFileName"></PdfImgViewer>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isPdfViewVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'
import { appjs } from '@/utiljs/apputil'
import { saveStandard, updateStandard, deleteStandard, queryStandard, exportStandard } from '@/api/contract/contract'
import PdfImgViewer from "@/components/pdfview/PdfImgViewer.vue";

export default {
  name: 'StandardManage',
  components: {
    PdfImgViewer
  },
  props: {
    clientHeight: {
      type: Number
    },
    url: {
      type: String
    }
  },
  data () {
    return {
      // 遮罩层
      loading: true,
      // 当前选中行
      currentRow: null,
      // 搜索文本
      searchText: '',
      // 查询参数
      queryParams: {
        currPage: 1,
        pageSize: 10,
        standardName: ''
      },
      isPdfViewVisible: false,
      viewFileName: '',
      // 总条数
      total: 0,
      // 标准列表
      standardList: [],
      // 对话框标题
      dialogTitle: '',
      // 是否显示对话框
      dialogVisible: false,
      // 文件上传相关
      uploadAction: '#',
      uploadHeaders: { Authorization: "Bearer " + getToken() },
      fileList: [],
      // 上传进度
      uploadProgress: 0,
      // 上传提示文本
      tipText: '',
      // 表单数据
      formData: {
        id: undefined,
        standardCode: '',
        standardName: '',
        standardExecuteDate: '',
        standardApproveDate: '',
        standardCancelDate: '',
        fileName: '',
        fileUrl: '',
        remark: ''
      },
      // 表单校验
      formRules: {
        standardCode: [{ required: true, message: '标准号不能为空', trigger: 'blur' }],
        standardName: [{ required: true, message: '标准名称不能为空', trigger: 'blur' }],
        standardApproveOrg: [{ required: true, message: '检测标准发布机构不能为空', trigger: 'blur' }],
        standardExecuteDate: [{ required: true, message: '启用日期不能为空', trigger: 'blur' }]
      },
    }
  },
  created () {
    this.getList()
  },
  methods: {
    /** 查询标准列表 */
    getList () {
      this.loading = true
      queryStandard(this.queryParams).then(res => {
        if (res) {
          this.standardList = res.dataList || []
          this.queryParams.pageSize = res.pageSize || 0
          this.queryParams.currPage = res.currPage || 0
          this.total = res.total || 0
        }
      }).finally(() => {
        this.loading = false
      })
    },
    /** 搜索按钮操作 */
    handleSearch () {
      this.queryParams.currPage = 1
      this.getList()
    },
    /** 分页大小改变事件 */
    handleSizeChange (val) {
      this.queryParams.pageSize = val
      this.queryParams.currPage = 1
      this.getList()
    },
    /** 当前页改变事件 */
    handleCurrentChange (val) {
      this.queryParams.currPage = val
      this.getList()
    },
    /** 表格行点击事件 */
    handleRowClick (row) {
      this.currentRow = row
    },
    /** 表格行样式 */
    tableRowClassName ({ row }) {
      if (this.currentRow && this.currentRow.id === row.id) {
        return 'current-row'
      }
      return ''
    },
    //上传文件
    uploadFile (fileData) {
      var _self = this;
      var formdata = new FormData();
      formdata.append("file", fileData.file);
      var name = fileData.file.name;
      var type = name.substring(name.lastIndexOf(".") + 1);
      formdata.append("fileType", type);

      // 重置上传进度
      this.uploadProgress = 0;
      this.tipText = "准备上传...";

      // 确保使用正确的API路径
      appjs.httpRequest('fileupload', formdata, "fileupload", function (event) {
        // 计算上传进度
        _self.uploadProgress = Math.round((event.loaded / event.total) * 100);
        _self.tipText = "文件上传中:" + _self.uploadProgress + "%";
      }).then((data) => {
        // 根据实际接口返回格式处理
        if (data.retCode && data.retCode === "ok") {
          fileData.onSuccess();
          // 设置文件信息到formData
          _self.formData.fileName = name;
          _self.formData.fileUrl = data.retMsg;
          _self.formData.standardFileUUID = data.retMsg; // 使用正确的字段名
          // 同时更新文件列表中的对象，确保包含所有必要字段
          _self.fileList = [{
            name: name,
            fileUUID: data.retMsg,
            url: data.retMsg
          }];
          _self.tipText = '上传完成！';
          _self.uploadProgress = 100;
          appjs.showSuccessMsg("上传成功");
        } else {
          fileData.onError();
          appjs.showErrorMsg(data.retMsg || '文件上传失败');
          _self.tipText = '';
          _self.uploadProgress = 0;
        }
      }).catch((error) => {
        fileData.onError();
        appjs.showErrorMsg("异常：" + error);
        _self.tipText = '';
        _self.uploadProgress = 0;
      })
    },
    /** 新增按钮操作 */
    handleAdd () {
      this.dialogTitle = '添加标准'
      this.dialogVisible = true
      this.formData = {
        id: undefined,
        standardCode: '',
        standardName: '',
        standardExecuteDate: '',
        standardApproveDate: '',
        standardCancelDate: '',
        standardFileUUID: '',
        fileName: '',
        fileUrl: '',
        remark: ''
      }
      this.fileList = []
      // 清空上传状态
      this.tipText = ''
      this.uploadProgress = 0
    },
    /** 修改按钮操作 */
    handleEdit (row) {
      this.dialogTitle = '修改标准'
      const standard = row || this.currentRow
      if (!standard) {
        this.$message.warning('请先选择要修改的标准')
        return
      }
      this.formData = { ...standard }
      // 确保正确设置ID字段（后端字段名为standardPid）
      this.formData.id = standard.standardPid
      // 如果有文件，设置文件列表
      if (standard.standardFileUUID) {
        this.fileList = [{
          name: standard.fileName || standard.standardFileUUID,
          fileUUID: standard.standardFileUUID,
          url: standard.standardFileUUID
        }]
        // 确保设置 formData.fileName 以便显示预览和清除按钮
        this.formData.fileName = standard.fileName || standard.standardFileUUID;
      } else {
        this.fileList = []
        this.formData.fileName = ''
      }
      // 清空上传状态
      this.tipText = ''
      this.uploadProgress = 0
      this.dialogVisible = true
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      const standard = row || this.currentRow
      if (!standard) {
        this.$message.warning('请先选择要删除的标准')
        return
      }

      // 获取标准ID，使用 standardPid 字段
      const standardId = standard.standardPid
      if (!standardId) {
        this.$message.error('无法获取标准ID，删除失败')
        return
      }

      this.$confirm(`是否确认删除标准 "${standard.standardName}"?`, '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 调用真实的删除API，传递 standardPid
        deleteStandard(standardId).then(res => {
          if (res && (res.code === 200 || res.retCode === "ok")) {
            this.$message.success('删除成功')
            this.getList()
            // 如果删除的是当前选中行，清除选中状态
            if (this.currentRow && this.currentRow.standardPid === standard.standardPid) {
              this.currentRow = null
            }
          } else {
            this.$message.error(res?.msg || res?.retMsg || '删除失败')
          }
        }).catch(error => {
          console.error('删除标准失败:', error)
          this.$message.error('删除失败：' + (error.message || '未知错误'))
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      this.$message.success('正在导出标准数据...')

      // 调用导出接口
      exportStandard(this.queryParams).then(response => {
        // 创建下载链接
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);

        // 创建下载链接元素
        const link = document.createElement('a');
        link.href = url;
        link.download = '标准名称.xlsx'; // 文件名

        // 触发下载
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();

        // 清理
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$message.success('导出成功')
      }).catch(error => {
        console.error('导出失败:', error)
        this.$message.error('导出失败：' + (error.message || '未知错误'))
      })
    },
    /** 对话框关闭事件 */
    handleDialogClose () {
      this.$refs.standardForm.resetFields()
      this.fileList = []
      // 清空上传状态
      this.tipText = ''
      this.uploadProgress = 0
      // 清空文件信息
      this.formData.fileName = ''
      this.formData.fileUrl = ''
      this.formData.fileUUID = ''
      this.formData.standardFileUUID = ''
    },
    /** 提交按钮 */
    submitForm () {
      this.$refs.standardForm.validate(valid => {
        if (valid) {
          // 确保使用正确的文件字段名
          if (this.fileList.length > 0) {
            // 使用 fileUUID 或 name 字段，确保获取正确的文件标识
            this.formData.standardFileUUID = this.fileList[0].fileUUID || this.fileList[0].name || '';
          } else {
            this.formData.standardFileUUID = '';
          }
          if (this.formData.id) {
            // 修改操作 - 使用导入的 updateStandard 函数
            updateStandard(this.formData).then(res => {
              // 根据实际接口返回格式处理
              if (res && (res.code === 200 || res.retCode === "ok")) {
                this.$message.success('修改成功')
                this.dialogVisible = false
                this.getList()
              } else {
                this.$message.error(res?.msg || res?.retMsg || '修改失败')
              }
            }).catch(error => {
              console.error('修改标准失败:', error)
              this.$message.error('修改失败：' + (error.message || '未知错误'))
            })
          } else {
            // 新增操作 - 使用导入的 saveStandard 函数
            saveStandard(this.formData).then(res => {
              // 根据实际接口返回格式处理
              if (res && (res.code === 200 || res.retCode === "ok")) {
                this.$message.success('保存成功')
                this.dialogVisible = false
                this.getList()
                // 清空表单
                this.formData = {
                  id: undefined,
                  standardCode: '',
                  standardName: '',
                  standardExecuteDate: '',
                  standardApproveDate: '',
                  standardCancelDate: '',
                  standardFileUUID: '', // 确保重置此字段
                  remark: ''
                }
              } else {
                this.$message.error(res?.msg || res?.retMsg || '保存失败')
              }
            }).catch(error => {
              console.error('保存标准失败:', error)
              this.$message.error('保存失败：' + (error.message || '未知错误'))
            })
          }
        }
      })
    },
    /** 文件上传成功处理 */
    handleFileSuccess (response, file, fileList) {
      // 这个方法可能不会被调用，因为我们使用了自定义的http-request
      // 但保留以防万一
      // if (response && (response.code === 200 || response.retCode === "ok")) {
      //   this.formData.fileName = response.fileName || file.name
      //   this.formData.fileUrl = response.retMsg || response.fileUrl
      //   this.$message.success('文件上传成功')
      // } else {
      //   this.$message.error(response?.msg || response?.retMsg || '文件上传失败')
      // }
    },
    /** 文件上传失败处理 */
    handleFileError (error, file, fileList) {
      // 这个方法可能不会被调用，因为我们使用了自定义的http-request
      // 但保留以防万一
      this.$message.error('文件上传失败：' + (error.message || '未知错误'))
    },
    /** 文件上传前处理 */
    beforeFileUpload (file) {
      const allowedTypes = ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/pdf']
      const maxSize = 10 * 1024 * 1024 // 10MB

      if (!allowedTypes.includes(file.type)) {
        this.$message.error('只能上传doc/docx/xls/xlsx/pdf文件')
        return false
      }

      if (file.size > maxSize) {
        this.$message.error('文件大小不能超过10MB')
        return false
      }

      return true
    },
    /** 清除已选择的文件 */
    clearFile () {
      this.formData.fileName = ''
      this.formData.fileUrl = ''
      this.formData.standardFileUUID = ''
      this.fileList = []
      this.tipText = ''
      this.uploadProgress = 0
      this.$refs.fileUpload.clearFiles()
    },
    // 在修改对话框中预览文件
    previewFileInDialog () {
      if (this.formData.standardFileUUID) {
        this.viewFileName = this.formData.standardFileUUID;
        this.isPdfViewVisible = true;
        this.$nextTick(() => {
          if (this.$refs.pdfImgViewer) {
            this.$refs.pdfImgViewer.init();
          }
        });
      }
    },

    // 添加文件下载方法
    downloadFile (fileUUID) {
      window.open('/api/tjmis/file/download/' + fileUUID, '_blank');
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}
.clearfix:after {
  clear: both;
}

.box-card {
  margin-bottom: 20px;
}

.el-table ::v-deep .current-row {
  background-color: #ecf5ff;
}

.upload-demo {
  width: 100%;
}

.file-info {
  margin-top: 10px;
  display: flex;
  align-items: center;
}

.file-info .el-tag {
  margin-right: 10px;
}
</style>